export enum SpecialPaymentProposalState {
  Approved = 'Approved',
  AutoApproved = 'AutoApproved',
  Rejected = 'Rejected',
  Pending = 'Pending'
}
